import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Pedido/duplicarPedido`, method: 'POST', body: values, token: token})
}
